import { Icon } from '@iconify/react'
import React, { InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string
    name: string
    labelClass: string
    placeholder: string
    disabled?: boolean
    isRequired?: Boolean
    maxLength?: number
}

const Input: React.FC<InputProps> = ({ id, className, label, placeholder, maxLength, isRequired, type, labelClass, ...rest }) => {
    return (
        <>
            <div className='w-full'>
                {label && (
                    <label htmlFor={id} className={labelClass}>
                        {label}
                        {isRequired && (
                            <span className='w-5 h-5'>
                                <Icon icon='mingcute:asterisk-2-fill' className='text-red' width='10' height='10' />
                            </span>
                        )}
                    </label>
                )}
                <div className='relative'>
                    <input
                        type={type}
                        id={id}
                        maxLength={maxLength}
                        autoComplete='off'
                        className={`${className && className}`}
                        {...rest}
                        placeholder={placeholder}
                    />
                </div>
            </div>
        </>
    )
}

export default Input
